import {registerRoute as workbox_routing_registerRoute} from '/app/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/app/node_modules/workbox-strategies/NetworkFirst.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/app/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/app/node_modules/workbox-strategies/CacheFirst.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/app/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {RangeRequestsPlugin as workbox_range_requests_RangeRequestsPlugin} from '/app/node_modules/workbox-range-requests/RangeRequestsPlugin.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/app/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/app/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/app/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */


importScripts(
  
);







self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/404.png",
    "revision": "6dde6c8b5261b92816d22390e3fd4069"
  },
  {
    "url": "/500.png",
    "revision": "ca29f732893c6145a39b0e2484d57962"
  },
  {
    "url": "/_next/app-build-manifest.json",
    "revision": "1f1eb9ea40d008a5ba48d865afb546e4"
  },
  {
    "url": "/_next/static/chunks/1029-906b45cd78feaf18.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/1029-906b45cd78feaf18.js.map",
    "revision": "b8087dd85ddd624bfd99a0eead92b271"
  },
  {
    "url": "/_next/static/chunks/1165.6571bd2ee8c9485a.js",
    "revision": "6571bd2ee8c9485a"
  },
  {
    "url": "/_next/static/chunks/1165.6571bd2ee8c9485a.js.map",
    "revision": "5937545df13a239e07dbfb6d7e2d63ee"
  },
  {
    "url": "/_next/static/chunks/1278-7e042137d3a913b9.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/1278-7e042137d3a913b9.js.map",
    "revision": "0c39ce878ba7e52d8cbc2775907070d5"
  },
  {
    "url": "/_next/static/chunks/1345.f235cff7baae9348.js",
    "revision": "f235cff7baae9348"
  },
  {
    "url": "/_next/static/chunks/1345.f235cff7baae9348.js.map",
    "revision": "6869432bc6fb0fcef044a1e2aab71afd"
  },
  {
    "url": "/_next/static/chunks/1378.1c12fd548f1c7088.js",
    "revision": "1c12fd548f1c7088"
  },
  {
    "url": "/_next/static/chunks/1416-5e6b89adeeab311d.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/1416-5e6b89adeeab311d.js.map",
    "revision": "e3a05e2829fba9273d6301a54fe218a2"
  },
  {
    "url": "/_next/static/chunks/1494-b375ca3c5c4d52fc.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/1494-b375ca3c5c4d52fc.js.map",
    "revision": "22d87b043296aa553e41799a40c18f92"
  },
  {
    "url": "/_next/static/chunks/1634.58f811d63e23e9f8.js",
    "revision": "58f811d63e23e9f8"
  },
  {
    "url": "/_next/static/chunks/1634.58f811d63e23e9f8.js.map",
    "revision": "42f052950ac21c9dd50336a4d4b0d2f4"
  },
  {
    "url": "/_next/static/chunks/1640.962ac617a4f684b4.js",
    "revision": "962ac617a4f684b4"
  },
  {
    "url": "/_next/static/chunks/1640.962ac617a4f684b4.js.map",
    "revision": "ccbe3d55dac5aae29380b91b34234ba5"
  },
  {
    "url": "/_next/static/chunks/1870-6f0dd59cf56f29ed.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/1870-6f0dd59cf56f29ed.js.map",
    "revision": "bcbdafa19887e72215216c1c27d64e5a"
  },
  {
    "url": "/_next/static/chunks/1964.9d5548627a0a5c98.js",
    "revision": "9d5548627a0a5c98"
  },
  {
    "url": "/_next/static/chunks/1964.9d5548627a0a5c98.js.map",
    "revision": "a2a4743bc5953f48b2855aa81d32cbd8"
  },
  {
    "url": "/_next/static/chunks/2012-d1137cd2fd2c5660.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/2012-d1137cd2fd2c5660.js.map",
    "revision": "21fff6b1d3972a4b4590ac764eec4645"
  },
  {
    "url": "/_next/static/chunks/2031-fef2b8bd8b38a94d.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/2031-fef2b8bd8b38a94d.js.map",
    "revision": "1d3c78ab33a4da9b46b2303df0cb429c"
  },
  {
    "url": "/_next/static/chunks/2037.322949b30a5e25d9.js",
    "revision": "322949b30a5e25d9"
  },
  {
    "url": "/_next/static/chunks/2117-148f283b05e46640.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/2117-148f283b05e46640.js.map",
    "revision": "e3459980774e598b27c6557b2e1c6fc8"
  },
  {
    "url": "/_next/static/chunks/221-9e890b26c6cc7e68.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/221-9e890b26c6cc7e68.js.map",
    "revision": "eeb3340877912076faf560bb568d9243"
  },
  {
    "url": "/_next/static/chunks/2399-e19cd2a37105cbb9.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/2399-e19cd2a37105cbb9.js.map",
    "revision": "02ea947370bcb9ddb83e45d71a0164f3"
  },
  {
    "url": "/_next/static/chunks/2682.2f0ca33412fcd6a1.js",
    "revision": "2f0ca33412fcd6a1"
  },
  {
    "url": "/_next/static/chunks/2704-44c6e087ecc84cde.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/2704-44c6e087ecc84cde.js.map",
    "revision": "656e245c08c1a66dbbf5180e593ee4c3"
  },
  {
    "url": "/_next/static/chunks/29-63583fc5753916a1.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/29-63583fc5753916a1.js.map",
    "revision": "ea521f623d50a2d370c25d56317d1fb2"
  },
  {
    "url": "/_next/static/chunks/2916.bf6441e491b4c530.js",
    "revision": "bf6441e491b4c530"
  },
  {
    "url": "/_next/static/chunks/2968.46cde8cff306bcf9.js",
    "revision": "46cde8cff306bcf9"
  },
  {
    "url": "/_next/static/chunks/3018.da78c1290bee1b19.js",
    "revision": "da78c1290bee1b19"
  },
  {
    "url": "/_next/static/chunks/3070-67a1d86acb34f3ec.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/3070-67a1d86acb34f3ec.js.map",
    "revision": "a66c4a0e8b5a3b920e4cb654fa12affe"
  },
  {
    "url": "/_next/static/chunks/3241.7800b99384dc6615.js",
    "revision": "7800b99384dc6615"
  },
  {
    "url": "/_next/static/chunks/3241.7800b99384dc6615.js.map",
    "revision": "0ba18adeb2cf6a63be0d3dbf667101b5"
  },
  {
    "url": "/_next/static/chunks/3573-6726a613a4c0cc27.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/3573-6726a613a4c0cc27.js.map",
    "revision": "7d499c277b40ed831521c5c4cb437fda"
  },
  {
    "url": "/_next/static/chunks/3621-cf7ce16cb4aed664.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/3621-cf7ce16cb4aed664.js.map",
    "revision": "f2c7db29a115c7a588fe6a4d46d3bf52"
  },
  {
    "url": "/_next/static/chunks/3761.3511b993b20a6dce.js",
    "revision": "3511b993b20a6dce"
  },
  {
    "url": "/_next/static/chunks/3895.355e65a72fb47d3b.js",
    "revision": "355e65a72fb47d3b"
  },
  {
    "url": "/_next/static/chunks/404-c2fdacf7275fcfe1.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/404-c2fdacf7275fcfe1.js.map",
    "revision": "57b50d3a2b5838a4d7348fa897ad55e0"
  },
  {
    "url": "/_next/static/chunks/408.c1c73b777355036c.js",
    "revision": "c1c73b777355036c"
  },
  {
    "url": "/_next/static/chunks/408.c1c73b777355036c.js.map",
    "revision": "e61643564b3ad368b36232d3642f3471"
  },
  {
    "url": "/_next/static/chunks/426.8551fdff35948582.js",
    "revision": "8551fdff35948582"
  },
  {
    "url": "/_next/static/chunks/426.8551fdff35948582.js.map",
    "revision": "953dcee71e4eaff401ce853c2e61208b"
  },
  {
    "url": "/_next/static/chunks/4334-609e01e7dd056bc2.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/4334-609e01e7dd056bc2.js.map",
    "revision": "34b7db6db8d3a03ce79abc3f620a01af"
  },
  {
    "url": "/_next/static/chunks/4395-fd46bbbbdfd6607b.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/4395-fd46bbbbdfd6607b.js.map",
    "revision": "51e8bb3f0b5a5a4476464dc20ad7ae0c"
  },
  {
    "url": "/_next/static/chunks/453-dfc35d903c9398ad.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/453-dfc35d903c9398ad.js.map",
    "revision": "65461d74505d81c4a5bdd1268076a67a"
  },
  {
    "url": "/_next/static/chunks/4565-7283eebfdb1858d9.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/4565-7283eebfdb1858d9.js.map",
    "revision": "f421fb36f754ab7f9aba0cc90d91e886"
  },
  {
    "url": "/_next/static/chunks/4623.2fda6472c7f8a109.js",
    "revision": "2fda6472c7f8a109"
  },
  {
    "url": "/_next/static/chunks/4892-240f3f59e5d22947.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/4892-240f3f59e5d22947.js.map",
    "revision": "12dafd166a258097e529e84ff7615767"
  },
  {
    "url": "/_next/static/chunks/4e6af11a-2161c09006140d6f.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/4e6af11a-2161c09006140d6f.js.map",
    "revision": "8d093ff2e8750154228a848975fabd9d"
  },
  {
    "url": "/_next/static/chunks/5005.06ba4ac9d4554ba9.js",
    "revision": "06ba4ac9d4554ba9"
  },
  {
    "url": "/_next/static/chunks/5178-ba59e1f00bd9aaf3.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/5178-ba59e1f00bd9aaf3.js.map",
    "revision": "a6e1674652f290b62cc9718bfa790b7a"
  },
  {
    "url": "/_next/static/chunks/5391-79035d06edea6171.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/5391-79035d06edea6171.js.map",
    "revision": "4d938cb201d5d12106cb87445d2920f9"
  },
  {
    "url": "/_next/static/chunks/5406.6c717e0c411dfe1d.js",
    "revision": "6c717e0c411dfe1d"
  },
  {
    "url": "/_next/static/chunks/5406.6c717e0c411dfe1d.js.map",
    "revision": "956ae91a016fdf75f5b05ed0fdc58e63"
  },
  {
    "url": "/_next/static/chunks/5514.837b074ce7885b5e.js",
    "revision": "837b074ce7885b5e"
  },
  {
    "url": "/_next/static/chunks/5582.6a5ca53f2a538db6.js",
    "revision": "6a5ca53f2a538db6"
  },
  {
    "url": "/_next/static/chunks/5582.6a5ca53f2a538db6.js.map",
    "revision": "3606c03ad16e60311f619f151e681f1f"
  },
  {
    "url": "/_next/static/chunks/5612-3432102a855d0640.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/5612-3432102a855d0640.js.map",
    "revision": "22088af00605f482de4cdf5597e8548c"
  },
  {
    "url": "/_next/static/chunks/568.adec4399b54b1aa2.js",
    "revision": "adec4399b54b1aa2"
  },
  {
    "url": "/_next/static/chunks/5761.da6827dcd565ca6a.js",
    "revision": "da6827dcd565ca6a"
  },
  {
    "url": "/_next/static/chunks/5761.da6827dcd565ca6a.js.map",
    "revision": "636fb7ad9d50f404d625a8e2937bdaa0"
  },
  {
    "url": "/_next/static/chunks/593.f157665338114b8e.js",
    "revision": "f157665338114b8e"
  },
  {
    "url": "/_next/static/chunks/593.f157665338114b8e.js.map",
    "revision": "55137b2fd42c72a6e77f8c44a50719b6"
  },
  {
    "url": "/_next/static/chunks/605-dc7266bb268ccd7a.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/605-dc7266bb268ccd7a.js.map",
    "revision": "f284ade5555511be8763c666d3f80af3"
  },
  {
    "url": "/_next/static/chunks/6107.d63e9c1d7fe24441.js",
    "revision": "d63e9c1d7fe24441"
  },
  {
    "url": "/_next/static/chunks/6107.d63e9c1d7fe24441.js.map",
    "revision": "c47e72804364434bd7995caab24d66bb"
  },
  {
    "url": "/_next/static/chunks/6213-625663eec119cdf9.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/6213-625663eec119cdf9.js.map",
    "revision": "b332240a8722b33ed3e148f137d64858"
  },
  {
    "url": "/_next/static/chunks/6312.485db9b623a7dd88.js",
    "revision": "485db9b623a7dd88"
  },
  {
    "url": "/_next/static/chunks/6312.485db9b623a7dd88.js.map",
    "revision": "276e054b6eaf675866639adae33db5fa"
  },
  {
    "url": "/_next/static/chunks/6573.d80b83eb3e58a38a.js",
    "revision": "d80b83eb3e58a38a"
  },
  {
    "url": "/_next/static/chunks/6573.d80b83eb3e58a38a.js.map",
    "revision": "f2d2aa8bbb58de4fcc6b6fafafa412c6"
  },
  {
    "url": "/_next/static/chunks/6612-86d72f59ce9656ad.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/6612-86d72f59ce9656ad.js.map",
    "revision": "c900e834f3278386246a367a5aac6d3a"
  },
  {
    "url": "/_next/static/chunks/6620.0cd5680b9b9d9145.js",
    "revision": "0cd5680b9b9d9145"
  },
  {
    "url": "/_next/static/chunks/6620.0cd5680b9b9d9145.js.map",
    "revision": "6de2e12625c98e673f63a89b271ba653"
  },
  {
    "url": "/_next/static/chunks/6714.08826f78e2bfe8f9.js",
    "revision": "08826f78e2bfe8f9"
  },
  {
    "url": "/_next/static/chunks/6714.08826f78e2bfe8f9.js.map",
    "revision": "a44c67eb8cb049643803b3a8e69cdca7"
  },
  {
    "url": "/_next/static/chunks/6754.c60ba9afeabc009b.js",
    "revision": "c60ba9afeabc009b"
  },
  {
    "url": "/_next/static/chunks/6754.c60ba9afeabc009b.js.map",
    "revision": "a3ebd2dd7787cb7dca62711940f2f8b0"
  },
  {
    "url": "/_next/static/chunks/6978-a3e5e8a8fa13cd6e.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/6978-a3e5e8a8fa13cd6e.js.map",
    "revision": "f7acf12b4e0180354309bc674f13ebe2"
  },
  {
    "url": "/_next/static/chunks/7082.fe9ffb95f676db77.js",
    "revision": "fe9ffb95f676db77"
  },
  {
    "url": "/_next/static/chunks/7091.f90d7fd0dcf25ea6.js",
    "revision": "f90d7fd0dcf25ea6"
  },
  {
    "url": "/_next/static/chunks/7091.f90d7fd0dcf25ea6.js.map",
    "revision": "6209ef54b2fdd137b45cef4edbcb05cb"
  },
  {
    "url": "/_next/static/chunks/7348.1336e00750576113.js",
    "revision": "1336e00750576113"
  },
  {
    "url": "/_next/static/chunks/7348.1336e00750576113.js.map",
    "revision": "d0e9c957452ac4d9b5ea2f782b398e54"
  },
  {
    "url": "/_next/static/chunks/7543.2ebb95e80680aa26.js",
    "revision": "2ebb95e80680aa26"
  },
  {
    "url": "/_next/static/chunks/7543.2ebb95e80680aa26.js.map",
    "revision": "264fdfc23f48021640e71c17453ff65c"
  },
  {
    "url": "/_next/static/chunks/7628.50cb7a505e1e0623.js",
    "revision": "50cb7a505e1e0623"
  },
  {
    "url": "/_next/static/chunks/7628.50cb7a505e1e0623.js.map",
    "revision": "e1dca146df7614b094a0f3054f3074c3"
  },
  {
    "url": "/_next/static/chunks/7905-0530d0d56a77499e.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/7905-0530d0d56a77499e.js.map",
    "revision": "e9afd6224da528ed556a55755c426041"
  },
  {
    "url": "/_next/static/chunks/7924.8f0379426017a3a8.js",
    "revision": "8f0379426017a3a8"
  },
  {
    "url": "/_next/static/chunks/7924.8f0379426017a3a8.js.map",
    "revision": "24e44ec2c5c1555380717a3902090214"
  },
  {
    "url": "/_next/static/chunks/798-e0c4fbbf5ee57b34.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/798-e0c4fbbf5ee57b34.js.map",
    "revision": "f482fb6ae2432b6431ad3dfb76d17426"
  },
  {
    "url": "/_next/static/chunks/7983-7c46e4aee90f3088.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/7983-7c46e4aee90f3088.js.map",
    "revision": "55e0a48c73a00ee942070d83e5537337"
  },
  {
    "url": "/_next/static/chunks/8019-3cee6773dac0ce87.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/8019-3cee6773dac0ce87.js.map",
    "revision": "e28a9efed9fcb4d1e782f24500301471"
  },
  {
    "url": "/_next/static/chunks/8086-c4aa88bbcf0116c2.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/8086-c4aa88bbcf0116c2.js.map",
    "revision": "df90017976b258ebf75b17064b23d18b"
  },
  {
    "url": "/_next/static/chunks/8109-db1390a43fb4f60c.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/8109-db1390a43fb4f60c.js.map",
    "revision": "f4b15d94011d4c4328e1427b5406e7d3"
  },
  {
    "url": "/_next/static/chunks/815-3ae7ceb96ab3add2.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/815-3ae7ceb96ab3add2.js.map",
    "revision": "1d1e540492632367f6bf2ced8839607d"
  },
  {
    "url": "/_next/static/chunks/8214-a0d2ca448db560ef.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/8214-a0d2ca448db560ef.js.map",
    "revision": "f52d6bcce1f8ddfee19daa163a4924c4"
  },
  {
    "url": "/_next/static/chunks/8292-48fe21ecde511e89.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/8292-48fe21ecde511e89.js.map",
    "revision": "e16f15e4f7cf92505f50acde78ca63b6"
  },
  {
    "url": "/_next/static/chunks/8462.b0293fd87407bf62.js",
    "revision": "b0293fd87407bf62"
  },
  {
    "url": "/_next/static/chunks/8462.b0293fd87407bf62.js.map",
    "revision": "9dbfca18a05995647819276a684f65a5"
  },
  {
    "url": "/_next/static/chunks/8495-aaba440bbf2b5541.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/8495-aaba440bbf2b5541.js.map",
    "revision": "2f992ec71a8860ee0ecbc0635ea7dd23"
  },
  {
    "url": "/_next/static/chunks/8514.6c5956eeca610b8c.js",
    "revision": "6c5956eeca610b8c"
  },
  {
    "url": "/_next/static/chunks/8514.6c5956eeca610b8c.js.map",
    "revision": "059477b935fbd628dfc876e59427d018"
  },
  {
    "url": "/_next/static/chunks/853-b0741c7a00fca6df.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/853-b0741c7a00fca6df.js.map",
    "revision": "59747e73cd38f7c8ecfa7782fd975e8b"
  },
  {
    "url": "/_next/static/chunks/8569.52bed89bd514a3a2.js",
    "revision": "52bed89bd514a3a2"
  },
  {
    "url": "/_next/static/chunks/8569.52bed89bd514a3a2.js.map",
    "revision": "f81e2864107c7bd7db508fd0631c229b"
  },
  {
    "url": "/_next/static/chunks/8667-dc0696bb6e11aa2e.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/8667-dc0696bb6e11aa2e.js.map",
    "revision": "9009f8395f91487a8a88a630be294681"
  },
  {
    "url": "/_next/static/chunks/8850.5b6dc4c5b98c6f7e.js",
    "revision": "5b6dc4c5b98c6f7e"
  },
  {
    "url": "/_next/static/chunks/8926-6d26cb9d11ab6c94.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/8926-6d26cb9d11ab6c94.js.map",
    "revision": "615f8671298ea27aa5ce4afd565fae3a"
  },
  {
    "url": "/_next/static/chunks/9233.d173b274100a412e.js",
    "revision": "d173b274100a412e"
  },
  {
    "url": "/_next/static/chunks/9556.2851d97dc62bede3.js",
    "revision": "2851d97dc62bede3"
  },
  {
    "url": "/_next/static/chunks/9556.2851d97dc62bede3.js.map",
    "revision": "ffaf2927ad3a80c2015914d1c8a8e9ac"
  },
  {
    "url": "/_next/static/chunks/9561.89eaae1c5034cb19.js",
    "revision": "89eaae1c5034cb19"
  },
  {
    "url": "/_next/static/chunks/9561.89eaae1c5034cb19.js.map",
    "revision": "d4bc01ee1394165701e3313f25834b56"
  },
  {
    "url": "/_next/static/chunks/9747-4efbb60de29832ad.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/9747-4efbb60de29832ad.js.map",
    "revision": "35dcb2db57d8821489babbc95d90c009"
  },
  {
    "url": "/_next/static/chunks/9927.8ea77f672bed7fac.js",
    "revision": "8ea77f672bed7fac"
  },
  {
    "url": "/_next/static/chunks/9927.8ea77f672bed7fac.js.map",
    "revision": "508831df2ac8b5c664f07dd831b9c2ab"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5B...not_found%5D/layout-96ea66fbaccfc8d9.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5B...not_found%5D/page-7bac2730838969d5.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/%5B...prettyurl%5D/page-c80a2c54224ce8b4.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/%5B...prettyurl%5D/page-c80a2c54224ce8b4.js.map",
    "revision": "604c0b98ec910d814f904c60faf94d5e"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(flatpage)/flat-page/%5Bpk%5D/layout-b61bd5e01a6c18c2.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(flatpage)/flat-page/%5Bpk%5D/loading-ea3f8bf17956e8d7.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(flatpage)/flat-page/%5Bpk%5D/loading-ea3f8bf17956e8d7.js.map",
    "revision": "aa0caf3a051478e7aef70a3b99ff44a7"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(flatpage)/flat-page/%5Bpk%5D/page-5f87126122c0ff2b.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(flatpage)/flat-page/%5Bpk%5D/page-5f87126122c0ff2b.js.map",
    "revision": "43dbf4e82eb8012f87749f866b52431d"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(orders)/layout-553a1d745886fd66.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(orders)/layout-553a1d745886fd66.js.map",
    "revision": "a7c32a2446019fb10a3d3845a8017b93"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(orders)/orders/checkout/page-741241dc6a4b3cc6.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(orders)/orders/checkout/page-741241dc6a4b3cc6.js.map",
    "revision": "400140da1639a91b28aaeb0a35af4d0e"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(orders)/orders/garanti-pay-redirect/page-222224aa6ad1efbb.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/address/page-a4ff4b02ef900d1c.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/address/page-a4ff4b02ef900d1c.js.map",
    "revision": "cd5022a33dabd3fd8dbf1becae2a0621"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/change-email/page-6942d758a3bd1a9d.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/change-email/page-6942d758a3bd1a9d.js.map",
    "revision": "87b1c18759672925765cef55975b7fdb"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/change-password/page-75ed913c3de35e86.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/change-password/page-75ed913c3de35e86.js.map",
    "revision": "d2ea357c77bf72f812d8b6b61d23c230"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/contact/page-70ad96e74d05029d.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/contact/page-70ad96e74d05029d.js.map",
    "revision": "22d6f20bc09cd78f374b73d7f22bf205"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/coupons/page-099e0ec115f9e2d2.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/coupons/page-099e0ec115f9e2d2.js.map",
    "revision": "3bc0987366948cbac64472fc62426574"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/email-verification/page-5b485708997382f5.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/email-verification/page-5b485708997382f5.js.map",
    "revision": "b093291249fcdeb57355e77130718a42"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/faq/%5B...slug%5D/page-49fabc238a85db0f.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/faq/%5B...slug%5D/page-49fabc238a85db0f.js.map",
    "revision": "55b3651290bbde8c55e09c44fd1d76d8"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/faq/page-6efc8f29712818ce.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/faq/page-6efc8f29712818ce.js.map",
    "revision": "fad6b33e9c173a340ccea8956406329d"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/favourite-products/page-311a4fc6e2c79c51.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/favourite-products/page-311a4fc6e2c79c51.js.map",
    "revision": "54ca72ec5bb7d6d1afdafd74570d3179"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/layout-ebbefbebad8c3b44.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/layout-ebbefbebad8c3b44.js.map",
    "revision": "90985db91650a34172e40f125b9155f2"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/notification-settings/page-81ebfef72a4b3599.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/notification-settings/page-81ebfef72a4b3599.js.map",
    "revision": "846b9ed1aee81a5d97326144cb2d9f93"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/orders/%5Bid%5D/cancellation/page-7989893f5038d6b6.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/orders/%5Bid%5D/cancellation/page-7989893f5038d6b6.js.map",
    "revision": "10f9c993fcd1fe9258aa2f9fdd937e9e"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/orders/%5Bid%5D/layout-146777ad20311a09.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/orders/%5Bid%5D/page-18edde2ad7dc9797.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/orders/%5Bid%5D/page-18edde2ad7dc9797.js.map",
    "revision": "b65ae2b43e3731cfdb136ac230db99e1"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/orders/page-23c317a50503b4f9.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/orders/page-23c317a50503b4f9.js.map",
    "revision": "eeacf4c3713329daebcfa813c2bce04a"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/page-b78f0c0105892398.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/page-b78f0c0105892398.js.map",
    "revision": "0fea6e15f3c76b1ae398fc32268b7c4c"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/profile/page-cb496aa8132b4400.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/profile/page-cb496aa8132b4400.js.map",
    "revision": "a1a72627a5ef847ff27ffbf7cff1c1d2"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/stock-waiting-products/page-831a243c78e272da.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/stock-waiting-products/page-831a243c78e272da.js.map",
    "revision": "8bbb27b0f4bee085f4739aeeaffecd59"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/supermember/page-d9cb5d2a41490b40.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/account/supermember/page-d9cb5d2a41490b40.js.map",
    "revision": "09999cb2e5699e201eb66766e40839cd"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/address/stores/page-ae3ddae9b1a411c7.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/address/stores/page-ae3ddae9b1a411c7.js.map",
    "revision": "4c1bd823c529e13d403de2fd79878001"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/anonymous-orders/page-4d972801b355eff0.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/anonymous-orders/page-4d972801b355eff0.js.map",
    "revision": "4be4f0427edfe12b7e119eb1137b6884"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/auth/forgot-password/page-0328c094ddf30407.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/auth/forgot-password/page-0328c094ddf30407.js.map",
    "revision": "d25667d6e113396475ed7b8644a47403"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/auth/guest/page-31b777123234f95b.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/auth/guest/page-31b777123234f95b.js.map",
    "revision": "12c06b306257fced2ad618fb37401ccc"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/auth/oauth-login/page-cfcda024501a8949.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/auth/oauth-login/page-cfcda024501a8949.js.map",
    "revision": "baf3c567dfd18612f984a6790aab750d"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/auth/page-d9dcde2a23a396ab.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/auth/page-d9dcde2a23a396ab.js.map",
    "revision": "5027e33613bfb8c77e84e69590b4d55e"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/auth/register/page-6afab6aa6495c9ab.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/auth/register/page-6afab6aa6495c9ab.js.map",
    "revision": "222dfd1f21a5296bdd10b8db1e9bedd3"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/basket/page-fe00492621764994.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/basket/page-fe00492621764994.js.map",
    "revision": "30ab2b1957d7f976122b2f55e6d24b31"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/category/%5Bpk%5D/loading-c3b6418f695f235e.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/category/%5Bpk%5D/page-ff0aabd980f86c12.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/category/%5Bpk%5D/page-ff0aabd980f86c12.js.map",
    "revision": "9a776f3cfa13a32683f89966574dd62a"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/cookie-policy/page-3f22482662bd4f4d.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/cookie-policy/page-3f22482662bd4f4d.js.map",
    "revision": "d761b4855114d6792fe0b83f8c1276e8"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/faq/%5B...slug%5D/page-c41702f694fd8b3a.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/faq/%5B...slug%5D/page-c41702f694fd8b3a.js.map",
    "revision": "112d84918f7ebf679053828deeb419e5"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/faq/page-7ffbb1164f7ebe39.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/faq/page-7ffbb1164f7ebe39.js.map",
    "revision": "ceef82da65fa75713047c73ba6140d2f"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/gizlilik/page-1e4db6e0c430af77.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/group-product/%5Bpk%5D/loading-fbcff7408586efe9.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/group-product/%5Bpk%5D/loading-fbcff7408586efe9.js.map",
    "revision": "425554d58f316a49fcef291146221b48"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/group-product/%5Bpk%5D/page-66432b5296e9fa60.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/group-product/%5Bpk%5D/page-66432b5296e9fa60.js.map",
    "revision": "ce22fe043028805671dee2ebc75715cb"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/hakkimizda/page-e02e0aa7dcf0418f.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/hakkimizda/page-e02e0aa7dcf0418f.js.map",
    "revision": "69daec87c6c31d9fd700294bbec07023"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/iade-iptal/page-66e54cbd46f7ad0e.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/kampanya-bilgilendirme/page-6ce0ab1b72f6c568.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/kampanya-bilgilendirme/page-6ce0ab1b72f6c568.js.map",
    "revision": "e6d5e462e6d577b3adff9240eac806e4"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/layout-d4d2825148cf3882.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/layout-d4d2825148cf3882.js.map",
    "revision": "b902a71c3f52f3df90af8f18b4b64422"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/list/loading-3227cc3fd7b96b76.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/list/page-a3016c323554d24e.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/list/page-a3016c323554d24e.js.map",
    "revision": "29a4a4da35b7e10ea03c940849d79ee9"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/markalar-landing/page-763241ec81964b85.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/markalar-landing/page-763241ec81964b85.js.map",
    "revision": "707781f2919b1700986146e06f4e6146"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/orders/completed/%5Btoken%5D/layout-e7a7030170c42784.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/orders/completed/%5Btoken%5D/layout-e7a7030170c42784.js.map",
    "revision": "bfa9ed4854aad7098c2d809355a12cee"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/orders/completed/%5Btoken%5D/page-5bc8ab54ca9dd40b.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/orders/completed/%5Btoken%5D/page-5bc8ab54ca9dd40b.js.map",
    "revision": "d0e02c9f0f9e7283cc64ef0a2da51554"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/orders/contract/page-20dc1fd5fde74c5b.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/orders/contract/page-20dc1fd5fde74c5b.js.map",
    "revision": "96cfca1199a6f9d1e7cce8b1a3668d91"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/page-4a024ee51bcc4fd8.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/page-4a024ee51bcc4fd8.js.map",
    "revision": "a818bc1e559872fda470133623ad431f"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/product/%5Bpk%5D/loading-4728487500a511de.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/product/%5Bpk%5D/page-ee86e26996d1eb71.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/product/%5Bpk%5D/page-ee86e26996d1eb71.js.map",
    "revision": "6e25d5cb8ced066c5f231a8896a1254c"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/sitemap/page-85d6502147061892.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/sitemap/page-85d6502147061892.js.map",
    "revision": "7555b76e0cca182d76f477954b830a1c"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/special-page/%5Bpk%5D/loading-700ad6ebdf9912ae.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/special-page/%5Bpk%5D/page-51cb8799f0e3f807.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/special-page/%5Bpk%5D/page-51cb8799f0e3f807.js.map",
    "revision": "85bf54e3d08ffae0e2916ce193dc32e6"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/stores/%5B...pk%5D/page-7a4820c6ae14f3ff.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/stores/%5B...pk%5D/page-7a4820c6ae14f3ff.js.map",
    "revision": "c3e40e961541b550b78a3ef5d0d3ebf8"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/stores/page-9932d48836831264.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/stores/page-9932d48836831264.js.map",
    "revision": "888bb1f59f1cdb05c2984bcb684d073f"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/superlife/(superlifeWithHeader)/%5Bslug%5D/page-e754bf33ac5e10dd.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/superlife/(superlifeWithHeader)/%5Bslug%5D/page-e754bf33ac5e10dd.js.map",
    "revision": "df07a864a784dfcf78588161b86a12a6"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/superlife/(superlifeWithHeader)/layout-51c15e5c74cb5d3c.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/superlife/(superlifeWithHeader)/layout-51c15e5c74cb5d3c.js.map",
    "revision": "235fd77b14d53c195e1ba4fbdcd37df7"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/superlife/(superlifeWithHeader)/page-edacf89a415bab83.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/superlife/(superlifeWithHeader)/page-edacf89a415bab83.js.map",
    "revision": "2afef2de05c728cf8eea77b68a5ff7b9"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/superlife/list/page-b6cb30826ce5ced8.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/superlife/list/page-b6cb30826ce5ced8.js.map",
    "revision": "2bb2a63127ba99db8655ff718b919b61"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/supermember/page-ff3a6e90b2a01911.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/supermember/page-ff3a6e90b2a01911.js.map",
    "revision": "270d88ac903648f90c9b13526e87aa1f"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/users/email-set-primary/%5B%5B...id%5D%5D/page-27d189206da65c3e.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/users/email-set-primary/%5B%5B...id%5D%5D/page-27d189206da65c3e.js.map",
    "revision": "42901470af76f1a6bdf7abccb2c0c97e"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/users/password/reset/page-3357ae8db55657ed.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/users/password/reset/page-3357ae8db55657ed.js.map",
    "revision": "e225bbdf59479fc488f9d33d56bf32ce"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/users/reset/%5B%5B...id%5D%5D/page-ee198384896d67de.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/users/reset/%5B%5B...id%5D%5D/page-ee198384896d67de.js.map",
    "revision": "9dc058c0008a959418690a002ea331e8"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/uyelik-sozlesmesi/page-646aa250793d46bf.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/(root)/uyelik-sozlesmesi/page-646aa250793d46bf.js.map",
    "revision": "2ce5135b4fe280cff001e0119e768704"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/agreement-check/page-e99c2c18fe2fdf8d.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/agreement-check/page-e99c2c18fe2fdf8d.js.map",
    "revision": "04dc5f6c062da39784d40c740405cba5"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/error-7c82aafda7d4c3a0.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/error-7c82aafda7d4c3a0.js.map",
    "revision": "f96f337609aed484d732db3a478bbb40"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/layout-d9bebf24470691af.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/layout-d9bebf24470691af.js.map",
    "revision": "95db585d8ef6aacb21a5b6129efb439e"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/superkids/layout-398484d3fa93b6da.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/superkids/layout-398484d3fa93b6da.js.map",
    "revision": "0a1f69928b9825b5b819511b45497f94"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/superkids/page-f0246792c0b76abc.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/superkids/page-f0246792c0b76abc.js.map",
    "revision": "9c459f8b5a5c007fe71b8acfd96aa70c"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/template-ea62ae0e0456ba0d.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/%5Bcurrency%5D/%5Burl%5D/template-ea62ae0e0456ba0d.js.map",
    "revision": "5877992d44e8537cc64eac550d50511a"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/layout-6b70b9c82773cbb8.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/layout-6b70b9c82773cbb8.js.map",
    "revision": "83ed72614d8b90ab1046775e63f1a184"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/not-found-6b01c371a50b45c8.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/%5Bcommerce%5D/%5Blocale%5D/not-found-6b01c371a50b45c8.js.map",
    "revision": "3475b5063ee93eb76f5f5d393e3d77e2"
  },
  {
    "url": "/_next/static/chunks/app/_not-found/page-6358f6603211b045.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/app/_not-found/page-6358f6603211b045.js.map",
    "revision": "1c7b945e81673273c4b0a3f98e6e9b02"
  },
  {
    "url": "/_next/static/chunks/fd9d1056-88f873eb6d4d2c0a.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/fd9d1056-88f873eb6d4d2c0a.js.map",
    "revision": "7f3616f5b9a21d634491ec1d688719d8"
  },
  {
    "url": "/_next/static/chunks/framework-5ecab0c61b5051c5.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/framework-5ecab0c61b5051c5.js.map",
    "revision": "5d8f86ee7c290878860878bed1172909"
  },
  {
    "url": "/_next/static/chunks/main-805450943b616b80.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/main-805450943b616b80.js.map",
    "revision": "73755eb84f9ca6d820d3f0804e6b5fd3"
  },
  {
    "url": "/_next/static/chunks/main-app-cb0c98814dcd64ff.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/main-app-cb0c98814dcd64ff.js.map",
    "revision": "09f6af205e72beb9a27f458b7c52da34"
  },
  {
    "url": "/_next/static/chunks/pages/_app-71f9680651ead193.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/pages/_app-71f9680651ead193.js.map",
    "revision": "1f5b6809e2392788f9d2febe735d8ede"
  },
  {
    "url": "/_next/static/chunks/pages/_error-9e0b91ca286a5103.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/pages/_error-9e0b91ca286a5103.js.map",
    "revision": "73eaba430b4634d222c2efbc54945fa5"
  },
  {
    "url": "/_next/static/chunks/polyfills-42372ed130431b0a.js",
    "revision": "846118c33b2c0e922d7b3a7676f81f6f"
  },
  {
    "url": "/_next/static/chunks/webpack-4e2db1d880a14616.js",
    "revision": "nBJ2M_r3Cwi_bPuaK8sNM"
  },
  {
    "url": "/_next/static/chunks/webpack-4e2db1d880a14616.js.map",
    "revision": "6ed86612de774fe2cd77b2665b2bad02"
  },
  {
    "url": "/_next/static/css/64d39cbc65902e5d.css",
    "revision": "64d39cbc65902e5d"
  },
  {
    "url": "/_next/static/css/64d39cbc65902e5d.css.map",
    "revision": "513c3abf2bf9487df5eb088bdb4d497f"
  },
  {
    "url": "/_next/static/css/8fdc948e91851c6f.css",
    "revision": "8fdc948e91851c6f"
  },
  {
    "url": "/_next/static/css/8fdc948e91851c6f.css.map",
    "revision": "559c7190b48346b609a80aec3fd1aa5e"
  },
  {
    "url": "/_next/static/css/b14d1469a9e0d50a.css",
    "revision": "b14d1469a9e0d50a"
  },
  {
    "url": "/_next/static/css/b14d1469a9e0d50a.css.map",
    "revision": "b6e4eadaedd7ce7ef77c7e862b8863b9"
  },
  {
    "url": "/_next/static/css/d62cc0fca6e4ebde.css",
    "revision": "d62cc0fca6e4ebde"
  },
  {
    "url": "/_next/static/css/d62cc0fca6e4ebde.css.map",
    "revision": "47d7a478b6f8a09ce0a8ee1b0e6e2905"
  },
  {
    "url": "/_next/static/css/f3af8a4ed229e2fb.css",
    "revision": "f3af8a4ed229e2fb"
  },
  {
    "url": "/_next/static/css/f3af8a4ed229e2fb.css.map",
    "revision": "ebd4914c1df3c3efaffb8f6f92e447d4"
  },
  {
    "url": "/_next/static/media/021bc4481ed92ece-s.woff2",
    "revision": "0f5cb8880dd308345f58cecdc5fc5041"
  },
  {
    "url": "/_next/static/media/3f69592b2fe603c7-s.woff2",
    "revision": "84568c0a37620328592a78e9ad069d77"
  },
  {
    "url": "/_next/static/media/4f05ba3a6752a328-s.woff2",
    "revision": "ea21cc6e4b393851204d1a3160ad6abc"
  },
  {
    "url": "/_next/static/media/6325a8417175c41d-s.woff2",
    "revision": "a3fd0c427e31c0cadb48607ee8c7876b"
  },
  {
    "url": "/_next/static/media/99b7f73d5af7c3e2-s.p.woff2",
    "revision": "e94b5e20c27aefc321077e0493d637fa"
  },
  {
    "url": "/_next/static/media/cursor-zoom.861ddc65.svg",
    "revision": "861ddc65"
  },
  {
    "url": "/_next/static/media/mp_amex.747126b2.jpg",
    "revision": "339faea2ae72eea42b91460207e7c7b5"
  },
  {
    "url": "/_next/static/media/mp_mastercard.96c69ff9.png",
    "revision": "e200e6fd6ab2c1c731670e68432955a4"
  },
  {
    "url": "/_next/static/media/mp_masterpass-logo.ef806d35.png",
    "revision": "832809360640465fe62dc73c6f0e3412"
  },
  {
    "url": "/_next/static/media/mp_other.bbc13412.png",
    "revision": "c791d896e712674c7bfd63cfed776163"
  },
  {
    "url": "/_next/static/media/mp_troy.88851a3c.png",
    "revision": "4de7840857dcd8ac6094e3e96603988e"
  },
  {
    "url": "/_next/static/media/mp_visa.971423d2.png",
    "revision": "a2347ab8f34a134d6bbfe1d0c62ff7ee"
  },
  {
    "url": "/_next/static/media/pz-icon.0ee8ba7b.ttf",
    "revision": "0ee8ba7b"
  },
  {
    "url": "/_next/static/media/pz-icon.1b21c3b0.eot",
    "revision": "1b21c3b0"
  },
  {
    "url": "/_next/static/media/pz-icon.8bc1531c.woff2",
    "revision": "8bc1531c"
  },
  {
    "url": "/_next/static/media/pz-icon.b2cf70a8.woff",
    "revision": "b2cf70a8"
  },
  {
    "url": "/_next/static/media/pz-icon.c2ea34ea.svg",
    "revision": "c2ea34ea"
  },
  {
    "url": "/_next/static/media/supermember-icon.b0fc38ae.svg",
    "revision": "13594b02919c37dfd87724faa8cec62c"
  },
  {
    "url": "/_next/static/media/vuesax-linear-ticket-star.e204ebad.png",
    "revision": "fb7e69a45075900ad9673133d2102490"
  },
  {
    "url": "/_next/static/nBJ2M_r3Cwi_bPuaK8sNM/_buildManifest.js",
    "revision": "25acee3192dacdcb23d9235972dd74ef"
  },
  {
    "url": "/_next/static/nBJ2M_r3Cwi_bPuaK8sNM/_ssgManifest.js",
    "revision": "b6652df95db52feb4daf4eca35380933"
  },
  {
    "url": "/account-header-bg.png",
    "revision": "02662efc6b69e358a198b65e5c03a155"
  },
  {
    "url": "/app-store.svg",
    "revision": "6b9720b70af03d2f6e70b93afa50f4eb"
  },
  {
    "url": "/checkout_success_app.jpg",
    "revision": "6f62b7c9d96f889e2dd27dc2fbaad9e6"
  },
  {
    "url": "/checkout_success_app.png",
    "revision": "db99326041dd12f1a3f241c113332cf2"
  },
  {
    "url": "/colors.png",
    "revision": "f7dc721a0592b80a196c41edb6116def"
  },
  {
    "url": "/cvv.png",
    "revision": "de02e5944eccf1bac6f2a6c135877f17"
  },
  {
    "url": "/default-no-image.png",
    "revision": "c02d6560a8d70362a10a0327ec4dcc2d"
  },
  {
    "url": "/etbis.png",
    "revision": "f3b3c8085a7db85ba6b5b29481ffe7dc"
  },
  {
    "url": "/etbis.svg",
    "revision": "4aca8b55ec224983cbf3ba2eda951362"
  },
  {
    "url": "/garantipay.svg",
    "revision": "de2cf38733a7a6421a3b0ca83ecd4024"
  },
  {
    "url": "/google-play.svg",
    "revision": "48a2738da122917c644c9b4865f1a496"
  },
  {
    "url": "/hoss-pin.svg",
    "revision": "af5c15620823fde9e66982bbb9017641"
  },
  {
    "url": "/hoss.svg",
    "revision": "93bab5ca2a122c6e65384553e8a4ee9e"
  },
  {
    "url": "/icon-192x192.png",
    "revision": "cec58a952222ad8ea43d7afa89197f64"
  },
  {
    "url": "/icon-256x256.png",
    "revision": "1553c4774886dd43d65bf31228e2889e"
  },
  {
    "url": "/icon-384x384.png",
    "revision": "3b92b7ae96d48f3e30ec87541f9d8a53"
  },
  {
    "url": "/icon-512x512.png",
    "revision": "37ad1fe6d663175aef5f56793fbd1cad"
  },
  {
    "url": "/icon-sprite.svg",
    "revision": "d4c81c1d2b0154c0b52b44d1940cd8b0"
  },
  {
    "url": "/l-o-g-o-superkids.svg",
    "revision": "134b450b0027b464ebea946c2bcb3ecc"
  },
  {
    "url": "/loader.gif",
    "revision": "2fb49b42a10f955dfe43aa3995bb005d"
  },
  {
    "url": "/locales/en/account.json",
    "revision": "485c61aebcc69813c5d0d7afcbce2044"
  },
  {
    "url": "/locales/en/auth.json",
    "revision": "64ca06b2b85af04ea74870ea5f8c6420"
  },
  {
    "url": "/locales/en/basket.json",
    "revision": "35376aa6d16352bb17df8ab505f1f0b9"
  },
  {
    "url": "/locales/en/category.json",
    "revision": "3d35cff142b9cac8bb9f485c8c2d6a1c"
  },
  {
    "url": "/locales/en/checkout.json",
    "revision": "9c90e89ebfae889af9c65fe2ed84c1ad"
  },
  {
    "url": "/locales/en/common.json",
    "revision": "970ce6ad2ae8c6370d9c576b7f0fed97"
  },
  {
    "url": "/locales/en/customer-service.json",
    "revision": "c2418e7308d0351ad8b53c94073ad57e"
  },
  {
    "url": "/locales/en/forgot_password.json",
    "revision": "49711278bfdd3b24b8350ebb7c8bb356"
  },
  {
    "url": "/locales/en/index.json",
    "revision": "d6399056810277e4217fd85fc59e423a"
  },
  {
    "url": "/locales/en/list.json",
    "revision": "249a3a62a7075a7c9610070dcf23b7fd"
  },
  {
    "url": "/locales/en/product.json",
    "revision": "3fb1201aa68a09a93942e796f8a28be7"
  },
  {
    "url": "/locales/en/store.json",
    "revision": "a2cecbfdae7c7f187ebf94eeec2b7614"
  },
  {
    "url": "/locales/en/superlife.json",
    "revision": "9707c93fdec0acb1aa7fe2e15a720cab"
  },
  {
    "url": "/locales/tr/account.json",
    "revision": "cb913c541269bdce9448fd47eef7ed45"
  },
  {
    "url": "/locales/tr/auth.json",
    "revision": "0a6ad8c133e9b32252c7bbfed0a106d6"
  },
  {
    "url": "/locales/tr/basket.json",
    "revision": "53c1e1130d0d2e5932f5634c52d79d0a"
  },
  {
    "url": "/locales/tr/category.json",
    "revision": "3ba440d9d52169a7d83b790dc6ed0100"
  },
  {
    "url": "/locales/tr/checkout.json",
    "revision": "b6d1da3d6e57beceb64a2fa197d25fa6"
  },
  {
    "url": "/locales/tr/common.json",
    "revision": "987af09ff00677183a51b22c618e8465"
  },
  {
    "url": "/locales/tr/customer-service.json",
    "revision": "9c6079f42db2c5dba3b569cdf2465af1"
  },
  {
    "url": "/locales/tr/forgot_password.json",
    "revision": "1af29592aacc38311bc09c14ca676855"
  },
  {
    "url": "/locales/tr/index.json",
    "revision": "3c9756bcfa841fd3780c35c89ef0b6b7"
  },
  {
    "url": "/locales/tr/list.json",
    "revision": "2782c64d5882fcaffad8be13108918c5"
  },
  {
    "url": "/locales/tr/product.json",
    "revision": "ca67c337549dd89b36fca76d85ad18f6"
  },
  {
    "url": "/locales/tr/store.json",
    "revision": "1416a124bec343830346bc66d7d4bbc3"
  },
  {
    "url": "/locales/tr/superlife.json",
    "revision": "b4ea92bad72d58089fd7c074d7593d89"
  },
  {
    "url": "/logo-hoss.svg",
    "revision": "6377eac01ac89b854fb1877051c99e25"
  },
  {
    "url": "/logo.svg",
    "revision": "3ca7bf617a0c136a4bcdd992dc172a1b"
  },
  {
    "url": "/manifest.json",
    "revision": "45932c716842de719873689d28603dc8"
  },
  {
    "url": "/mastercard.png",
    "revision": "6edab6d626c5f041235585767ecfa221"
  },
  {
    "url": "/masterpass.json",
    "revision": "79f03b208295e36d66b88c9f9fd8d7ca"
  },
  {
    "url": "/mastersecure.png",
    "revision": "5f4f1a282759c6ed3938bde622de3898"
  },
  {
    "url": "/mfs-client.min.js",
    "revision": "41347566302aec7e431a2d1349f86478"
  },
  {
    "url": "/mp_masterpass-logo-white.png",
    "revision": "7947fc066fbfaa33a6d04d981fd4c19b"
  },
  {
    "url": "/mp_masterpass-logo.png",
    "revision": "832809360640465fe62dc73c6f0e3412"
  },
  {
    "url": "/noimage.jpg",
    "revision": "82460b58ae6d0db84b93aa4b1f7308b1"
  },
  {
    "url": "/relatedpush_sw.js",
    "revision": "47e9139c832bbe6a9b5ae312677ebe94"
  },
  {
    "url": "/safari-pinned-tab.svg",
    "revision": "33a1d9ffebe6a89ebf180c76a6a40110"
  },
  {
    "url": "/security-payment.svg",
    "revision": "1745e53dd0df90070a7273b35ee7688e"
  },
  {
    "url": "/ssl-secure.png",
    "revision": "af4e0de8549681d1ee5df29a6be959a0"
  },
  {
    "url": "/superkids-pin.svg",
    "revision": "e3de0dfc0bf8783722e28721f686a354"
  },
  {
    "url": "/superlife-header-bg.png",
    "revision": "6e7708134211d87a0c2fac9733874dc9"
  },
  {
    "url": "/supermember-icon.svg",
    "revision": "13594b02919c37dfd87724faa8cec62c"
  },
  {
    "url": "/supermember-logo.svg",
    "revision": "c79c159c9918962e2cb6b5a97b8f359f"
  },
  {
    "url": "/superstep-pin.svg",
    "revision": "e430cdb5b8dbbafc4a93cbc4ee29cb07"
  },
  {
    "url": "/vbv.png",
    "revision": "9cc5bb174d3b6bf92d349f04b3ba7ebf"
  },
  {
    "url": "/visa.png",
    "revision": "687df134aa36fd286c8be449df2e8dc3"
  },
  {
    "url": "/vuesax-linear-ticket-star.png",
    "revision": "fb7e69a45075900ad9673133d2102490"
  },
  {
    "url": "/vuesax_linear_box-tick.svg",
    "revision": "b444670fdfabadddd0b858f51a66a7d8"
  },
  {
    "url": "/vuesax_linear_group.svg",
    "revision": "4fffcef1f89709731c826d89c36d9f78"
  },
  {
    "url": "/vuesax_linear_rotate-left.svg",
    "revision": "4aae6a2a87be07a001896fb83ce53d75"
  },
  {
    "url": "/vuesax_linear_shield-tick.svg",
    "revision": "d637f9be9f1347ca66a4d00148669393"
  },
  {
    "url": "/white-bg.png",
    "revision": "b4c9cd244a738a5c867a3dda3363ffdd"
  },
  {
    "url": "/zepto.min.js",
    "revision": "8c817bd2e1b159a32ed3830df191dab5"
  }
], {
  "ignoreURLParametersMatching": []
});
workbox_precaching_cleanupOutdatedCaches();



workbox_routing_registerRoute("/", new workbox_strategies_NetworkFirst({ "cacheName":"start-url", plugins: [{ cacheWillUpdate: async ({ request, response, event, state }) => { if (response && response.type === 'opaqueredirect') { return new Response(response.body, { status: 200, statusText: 'OK', headers: response.headers }) } return response } }] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/fonts\.(?:gstatic)\.com\/.*/i, new workbox_strategies_CacheFirst({ "cacheName":"google-fonts-webfonts", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 4, maxAgeSeconds: 31536000 })] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/fonts\.(?:googleapis)\.com\/.*/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"google-fonts-stylesheets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 4, maxAgeSeconds: 604800 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:eot|otf|ttc|ttf|woff|woff2|font.css)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-font-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 4, maxAgeSeconds: 604800 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:jpg|jpeg|gif|png|svg|ico|webp)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-image-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 64, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\/_next\/image\?url=.+$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"next-image", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 64, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:mp3|wav|ogg)$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-audio-assets", plugins: [new workbox_range_requests_RangeRequestsPlugin(), new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:mp4)$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-video-assets", plugins: [new workbox_range_requests_RangeRequestsPlugin(), new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:js)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-js-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:css|less)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-style-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\/_next\/data\/.+\/.+\.json$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"next-data", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:json|xml|csv)$/i, new workbox_strategies_NetworkFirst({ "cacheName":"static-data-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(({ url }) => {
      const isSameOrigin = self.origin === url.origin
      if (!isSameOrigin) return false
      const pathname = url.pathname
      // Exclude /api/auth/callback/* to fix OAuth workflow in Safari without impact other environment
      // Above route is default for next-auth, you may need to change it if your OAuth workflow has a different callback route
      // Issue: https://github.com/shadowwalker/next-pwa/issues/131#issuecomment-821894809
      if (pathname.startsWith('/api/auth/')) return false
      if (pathname.startsWith('/api/')) return true
      return false
    }, new workbox_strategies_NetworkFirst({ "cacheName":"apis","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 16, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(({ url }) => {
      const isSameOrigin = self.origin === url.origin
      if (!isSameOrigin) return false
      const pathname = url.pathname
      if (pathname.startsWith('/api/')) return false
      return true
    }, new workbox_strategies_NetworkFirst({ "cacheName":"others","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(({ url }) => {
      const isSameOrigin = self.origin === url.origin
      return !isSameOrigin
    }, new workbox_strategies_NetworkFirst({ "cacheName":"cross-origin","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 3600 })] }), 'GET');




